import React, {useState} from 'react'
import {Popover} from "antd";
import {EllipsisOutlined} from "@ant-design/icons";
import OfferActionsList from "./OfferActionsList";


const OfferActions = ({offerId, updater}) => {

    const [showPop, setShowPop] = useState(false)

    const handlePopChange = () => {
        setShowPop(!showPop)
    }

    return(
        <React.Fragment>
            <Popover
                className={'offer-action-more'}
                content={
                    <OfferActionsList popChange={handlePopChange} updater={updater} offerId={offerId}  />
                }
                title={'İşlem Listesi'}
                trigger={'click'}
                open={showPop}
                onOpenChange={handlePopChange}
            >

                <EllipsisOutlined />
            </Popover>
        </React.Fragment>
    )
}
export default OfferActions